import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import {BehaviorSubject, Observable} from 'rxjs';
import {ToggleFormData} from '../models/update-select-form';


@Injectable({
  providedIn: 'root'
})
export class UpdateDynamicFormService  {
  private subject =  new BehaviorSubject<ToggleFormData[]>([]) ;
  result: ToggleFormData[];
  constructor() {
    this.result = [];
  }
  /**
   * cette fonction sauvegarde dans un observable les contrôlleurs a updater  + update du statut si existant.
   * @param le nom du controlleur à updater
   * @param statuts boolean
   * @param type d'update (warning, toggle)
   *
   */
  updateElement(name: string , status: boolean , type: string ): void {
    const index =  _.findIndex(this.result, function (o: ToggleFormData): boolean { return o.controlName === name; });
    if (index === -1) {
      this.result.push({'controlName': name , 'status': status , 'type': type });
    } else {
      this.result[index].status = status;
      this.result[index].type = type;
    }
    this.subject.next(this.result);
  }

  status(name: string): ToggleFormData {
    const index =  _.findIndex(this.result, function (o: ToggleFormData): boolean { return o.controlName === name; });
    if (index !== -1) {
      return this.result[index];
    } else {
      return null
    }
  }

  getResponse(): Observable<object> {
    return this.subject.asObservable();
  }

  clear(): void {
    this.result = [];
  }
}
